import { render, staticRenderFns } from "./DistributorSecondVipIndex.vue?vue&type=template&id=598f676b"
import script from "./DistributorSecondVipIndex.vue?vue&type=script&lang=js"
export * from "./DistributorSecondVipIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports